var map = {
	"./admin.svg": 50747,
	"./audit.svg": 24327,
	"./auditlogs.svg": 39210,
	"./debug-permissions.svg": 27316,
	"./dpwtstats.svg": 74716,
	"./encoders.svg": 4293,
	"./icons/fonts/blishly.svg": 48405,
	"./icons/update/fonts/ma.svg": 54828,
	"./liveops.svg": 74772,
	"./mam.svg": 48761,
	"./mgw.svg": 73465,
	"./monitor.svg": 46532,
	"./multiview.svg": 81890,
	"./multiviewer.svg": 88651,
	"./multiviewernew.svg": 66903,
	"./mv.svg": 16907,
	"./mvr.svg": 2451,
	"./newFile.svg": 44502,
	"./permissionssimple.svg": 70848,
	"./probes.svg": 85479,
	"./reports.svg": 36107,
	"./router.svg": 48929,
	"./routeralt.svg": 87226,
	"./schedule-status-legend.svg": 9362,
	"./schedule.svg": 23637,
	"./scheduleagenda.svg": 14197,
	"./servers.svg": 59406,
	"./sourcemonitoring.svg": 78339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91980;